import { SearchOutlined } from '@ant-design/icons';
import { Input, Splitter } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import slugify from 'slugify';
import { useGetCategoriesTree } from '../../../../utils/api/categories/useGetCategoriesTree';
import '../categories.css';
import CategoryDetails from '../details';
import CategoriesTree from './CategoriesTree';

const CategoriesList = () => {
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [sizes, setSizes] = useState(['30%', '70%']);

  const { categories, isLoading, isError, refetch } = useGetCategoriesTree({
    search: debouncedSearch || undefined,
  });

  const handleCategorySelect = useCallback(
    (selectedKeys, info) => {
      if (selectedKeys.length > 0 && info.selected) {
        setSelectedCategory(info.node);
        navigate(
          `/dashboard/categories/${slugify(info.node?.title)}/category-attributes`
        );
      } else {
        setSelectedCategory(null);
      }
    },
    [navigate]
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
    }, 300);

    return () => clearTimeout(timer);
  }, [search]);

  return (
    <div
      style={{
        height: 'calc(100vh - 120px)',
        display: 'flex',
        flexDirection: 'column',
      }}
      className="categories-container"
    >
      <Splitter onResize={setSizes} style={{ height: '100%' }}>
        <Splitter.Panel size={sizes[0]} resizable={true}>
          <div
            style={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              flex: 1,
              padding: '16px',
            }}
          >
            <h2 style={{ margin: '0 0 14px 0' }}>Catégories brutes</h2>
            <div style={{ marginTop: '16px' }}>
              <Input
                value={search}
                placeholder="Rechercher une catégorie"
                prefix={<SearchOutlined />}
                onChange={(e) => setSearch(e.target.value)}
                allowClear
              />
            </div>
            <div
              style={{
                flex: 1,
                overflowY: 'auto',
                minHeight: 0,
                padding: '16px',
              }}
            >
              <CategoriesTree
                categories={categories}
                onSelect={handleCategorySelect}
                loading={isLoading}
              />
            </div>
            {isError && (
              <div
                style={{
                  color: '#ff4d4f',
                  textAlign: 'center',
                  padding: '20px',
                }}
              >
                <div>Erreur lors du chargement des catégories</div>
                <button
                  onClick={() => refetch()}
                  style={{
                    marginTop: '10px',
                    padding: '8px 16px',
                    cursor: 'pointer',
                    backgroundColor: '#1890ff',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                  }}
                >
                  Réessayer
                </button>
              </div>
            )}
          </div>
        </Splitter.Panel>
        <Splitter.Panel size={sizes[1]}>
          <div
            style={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              flex: 1,
              overflowY: 'auto',
            }}
          >
            <div style={{ padding: '16px' }}>
              <CategoryDetails category={selectedCategory} />
            </div>
          </div>
        </Splitter.Panel>
      </Splitter>
    </div>
  );
};

export default CategoriesList;
